var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-settings-option"},[_c('label',[_c('input',_vm._b({attrs:{"name":_vm.name,"type":"checkbox"},on:{"change":_vm.onUpdate}},'input',{checked: _vm.value},false)),_vm._v(" "+_vm._s(_vm.title))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }